// ---------------------------------------------------------------------------
// Pure workspace classification helpers (extracted from index.ts to break the
// active-workspace-context.tsx <-> index.ts cycle)
// ---------------------------------------------------------------------------

import type { WorkspaceDetailed } from "./api";

export type WorkspaceGroup = "personal" | "team" | "admin";

export function classifyWorkspace(entry: WorkspaceDetailed): WorkspaceGroup {
    if (entry.workspace.isPersonal) return "personal";
    if (!entry.isOwner && entry.userRole === "admin") return "admin";
    return "team";
}

export function groupWorkspaces(entries: WorkspaceDetailed[]): Record<WorkspaceGroup, WorkspaceDetailed[]> {
    const groups: Record<WorkspaceGroup, WorkspaceDetailed[]> = {
        personal: [],
        team: [],
        admin: [],
    };
    for (const entry of entries) {
        groups[classifyWorkspace(entry)].push(entry);
    }
    return groups;
}
